'use strict';

var _ = require('lodash');
function ServiceManagementDataTransformService(helper, momentService, bookingsIntakeTransformer, featureToggle) {
  function initializeDistinctClassNames(resources, flowType) {
    var distinctInventoryControls = _.reduce(resources, function (distinctInventoryControls, resource) {
      // NOTE: Mapped / Regular Value returns on selected flowtype
      var inventoryControls = _.filter(resource.serviceInventoryControls, function (inventoryControl) {
        return inventoryControl.flowType === flowType;
      });
      return _.unionBy(distinctInventoryControls, inventoryControls, 'className');
    }, []);
    return _.map(distinctInventoryControls, _.partialRight(_.pick, 'className'));
  }
  function transform(serviceResponse, controlType) {
    var memorizedMomentOfDepartureDate = _.memoize(helper.getMomentOfDate);
    var memorizedMomentOfDepartureTime = _.memoize(helper.getMomentOfTime);
    var memorizedMomentOfEventTimeStamp = _.memoize(helper.getMomentOfDate);
    var serviceClassControlEnabled = featureToggle.isEnabled('SERVICE_CLASS_CONTROL');
    var inventoryControlsMetrics = serviceClassControlEnabled ? {
      Availability: 'availEffective',
      Authorization: 'authEffective',
      Bookings: 'bookingEffective'
    } : {
      Availability: 'availability'
    };
    var flowType = featureToggle.isEnabled('MAPPED_MODE') ? 'REGULAR' : 'MAPPED';
    var serviceResponseResults = _.get(serviceResponse, 'results', []);
    var distinctClassNames = initializeDistinctClassNames(serviceResponseResults, flowType);
    var services = _.transform(serviceResponseResults, function (result, el) {
      var compFareDiff = _.isNumber(el.hostFare) && _.isNumber(el.lowestCompFare) ? el.hostFare - el.lowestCompFare : null;
      var newEntry = {
        //Technical Fields
        daysToDeparture: el.daysToDeparture,
        flightNumber: el.flightNumber,
        carrier: el.carrier,
        serviceId: el.serviceId,
        scenarioName: el.scenarioName,
        lastYearBookings: el.lastYearBookings,
        lastYearMappedBookings: el.lastYearMappedBookings,
        lastYearCurrentRevenue: el.lastYearCurrentRevenue,
        lastYearMappedCurrentRevenue: el.lastYearMappedCurrentRevenue,
        lowestCompFare: el.lowestCompFare,
        mappedBidPrice: el.mappedBidPrice,
        lastYearFinalBookings: el.lastYearFinalBookings,
        lastYearMappedFinalBookings: el.lastYearMappedFinalBookings,
        lastYearFinalRevenue: el.lastYearFinalRevenue,
        lastYearMappedFinalRevenue: el.lastYearMappedFinalRevenue,
        mappedTripBookings: el.mappedTripBookings,
        regularTripBookings: el.regularTripBookings,
        numberOfAlertRulesApplied: el.numberOfAlertRulesApplied,
        referenceCurveServiceId: el.referenceCurveServiceId,
        appliedRules: el.appliedRules,
        appliedRulesNumber: _.uniq(el.appliedRules).length,
        latestChanges: el.latestChanges,
        associatedLegCabins: el.associatedLegCabins,
        route: el.route,
        spos: el.spos,
        bookings: el.bookings,
        mappedBookings: el.mappedBookings,
        currentRevenue: el.currentRevenue,
        mappedCurrentRevenue: el.mappedCurrentRevenue,
        groupBookings: el.groupBookings,
        mappedGroupBookings: el.mappedGroupBookings,
        hostFare: el.hostFare,
        bidPrice: el.bidPrice,
        expectedBookings: el.expectedBookings,
        expectedRevenue: el.expectedRevenue,
        mappedExpectedRevenue: el.mappedExpectedRevenue,
        mappedExpectedBookings: el.mappedExpectedBookings,
        compFareDiff: compFareDiff,
        alertScore: el.alertScore,
        isDiscontinued: el.isDiscontinued ? 'Yes' : 'No',
        isManuallyControlled: _.isNil(el.userRegularIsManuallyControlled) ? el.isManuallyControlled ? 'Yes' : 'No' : el.userRegularIsManuallyControlled === 'true' ? 'Yes' : 'No',
        // Moment Fields
        departureDateMoment: memorizedMomentOfDepartureDate(el.departureDate, momentService.FIELD.DEPARTURE_DATE),
        departureTimeMoment: memorizedMomentOfDepartureTime(el.departureTime, momentService.FIELD.DEPARTURE_TIME, memorizedMomentOfDepartureDate),
        eventTimeStampMoment: memorizedMomentOfEventTimeStamp(el.eventTimeStamp, momentService.FIELD.EVENT_TIME_STAMP),
        // Trend indicator
        customClasses: {
          bookings: helper.getTrendClass(el.bookings, el.lastYearBookings),
          mappedBookings: helper.getTrendClass(el.mappedBookings, el.lastYearMappedBookings),
          currentRevenue: helper.getTrendClass(el.currentRevenue, el.lastYearCurrentRevenue),
          mappedCurrentRevenue: helper.getTrendClass(el.mappedCurrentRevenue, el.lastYearMappedCurrentRevenue),
          compFareDiff: helper.getTrendClass(el.hostFare, el.lowestCompFare),
          expectedBookings: helper.getTrendClass(el.expectedBookings, el.lastYearFinalBookings),
          mappedExpectedBookings: helper.getTrendClass(el.mappedExpectedBookings, el.lastYearMappedFinalBookings),
          expectedRevenue: helper.getTrendClass(el.expectedRevenue, el.lastYearFinalRevenue),
          mappedExpectedRevenue: helper.getTrendClass(el.mappedExpectedRevenue, el.lastYearMappedFinalRevenue)
        }
      };

      // NOTE: Mapped / Regular Value returns on selected flowtype
      var inventoryControls = _.filter(el.serviceInventoryControls, function (inventoryControl) {
        return inventoryControl.flowType === flowType;
      });
      helper.generateInventoryControls(inventoryControls, distinctClassNames, newEntry, inventoryControlsMetrics, controlType);
      helper.generateLoadFactors(el.legLoadFactorDetails, newEntry);
      helper.generateDemandColumns(el.serviceInventoryControls, newEntry);
      bookingsIntakeTransformer.calculateBookingsIntake(newEntry, el);
      result.push(newEntry);
      return result;
    });
    bookingsIntakeTransformer.createBookingsIntakeHtml(services);
    return services;
  }
  return {
    transform: transform
  };
}
ServiceManagementDataTransformService.$inject = ['FlightManagementDataRetrieverHelperService', 'MomentService', 'BookingsIntakeTransformationService', 'FeatureToggleService'];
module.exports = ServiceManagementDataTransformService;